import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SavePopupResponseInput } from '@/models/caller';

export const saveGourmetPopupResponse = async ({ phoneNumber, clientResponse, notInterestedReason }: SavePopupResponseInput) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      clientResponse,
      notInterestedReason,
    },
    mutation: graphql(`
      mutation SaveGourmetPopupResponse($phoneNumber: String!, $clientResponse: String!, $notInterestedReason: String) {
        saveGourmetPopupResponse(phoneNumber: $phoneNumber, clientResponse: $clientResponse, notInterestedReason: $notInterestedReason) {
          id
          gourmetPopup {
            callSid
            clientResponse
            notInterestedReason
          }
        }
      }
    `),
  });

  return response.data?.saveGourmetPopupResponse;
};
